import { render, staticRenderFns } from "./data-inventory-faq.vue?vue&type=template&id=c0ea1f90&"
import script from "./data-inventory-faq.vue?vue&type=script&lang=js&"
export * from "./data-inventory-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports